import React from 'react';

import { Chip } from '@infoods/lifebase-ui';
import classes from './WidgetHeaderActions.module.scss';
import {
  ModeButtonsBlock,
  ModeButtonsBlockProps,
} from '../../../../../../../shared/components/buttons/ModeButtonsBlock/ModeButtonsBlock';

type WidgetHeaderActionsProps = ModeButtonsBlockProps & {
  isInvalid?: boolean;
};

const WidgetHeaderActions = ({
  mode,
  isInvalid,
  ...modeButtonsBlockProps
}: WidgetHeaderActionsProps) => {
  return (
    <div className={classes.container}>
      {isInvalid && mode === 'VIEW' && (
        <Chip label="Complete setup" color="error" size="small" />
      )}
      <ModeButtonsBlock mode={mode} {...modeButtonsBlockProps} />
    </div>
  );
};

export { WidgetHeaderActions };
